import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, FileText, Pill, FlaskConical, Star, Download, ArrowRight } from 'lucide-react';
export function VisitSummaryScreen() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-ui-bg flex flex-col" data-id="element-1825">
      <div className="bg-brand-primary pt-12 pb-8 px-6 text-center rounded-b-[32px] shadow-sm" data-id="element-1826">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm" data-id="element-1827">
          <CheckCircle size={32} className="text-white" data-id="element-1828" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-1" data-id="element-1829">Visit Completed</h1>
        <p className="text-brand-light text-sm" data-id="element-1830">
          Your consultation with Dr. Amina Bello has ended.
        </p>
      </div>

      <div className="flex-1 px-6 py-6 space-y-6 overflow-y-auto" data-id="element-1831">
        {/* Diagnosis Card */}
        <div className="bg-white rounded-2xl p-5 border border-ui-border shadow-sm" data-id="element-1832">
          <div className="flex items-center mb-3" data-id="element-1833">
            <FileText size={20} className="text-brand-primary mr-2" data-id="element-1834" />
            <h2 className="font-bold text-text-main" data-id="element-1835">Diagnosis Summary</h2>
          </div>
          <p className="text-sm text-text-secondary leading-relaxed" data-id="element-1836">
            Patient presents with mild viral upper respiratory tract infection.
            Symptoms include low-grade fever and headache. No signs of bacterial
            infection. Advised rest and hydration.
          </p>
        </div>

        {/* Prescription Card */}
        <div className="bg-white rounded-2xl p-5 border border-ui-border shadow-sm border-l-4 border-l-brand-primary" data-id="element-1837">
          <div className="flex justify-between items-start mb-4" data-id="element-1838">
            <div className="flex items-center" data-id="element-1839">
              <Pill size={20} className="text-brand-primary mr-2" data-id="element-1840" />
              <h2 className="font-bold text-text-main" data-id="element-1841">Prescription</h2>
            </div>
            <button className="text-brand-primary" data-id="element-1842">
              <Download size={18} data-id="element-1843" />
            </button>
          </div>

          <div className="space-y-3" data-id="element-1844">
            <div className="bg-ui-card p-3 rounded-xl" data-id="element-1845">
              <p className="font-bold text-sm text-text-main" data-id="element-1846">
                Paracetamol 500mg
              </p>
              <p className="text-xs text-text-secondary mt-1" data-id="element-1847">
                Take 2 tablets every 8 hours for 3 days.
              </p>
            </div>
            <div className="bg-ui-card p-3 rounded-xl" data-id="element-1848">
              <p className="font-bold text-sm text-text-main" data-id="element-1849">
                Vitamin C 1000mg
              </p>
              <p className="text-xs text-text-secondary mt-1" data-id="element-1850">
                Take 1 tablet daily for 7 days.
              </p>
            </div>
          </div>

          <button className="w-full mt-4 bg-brand-primary text-white font-semibold py-3 rounded-xl text-sm flex items-center justify-center shadow-sm" data-id="element-1851">
            Order Medication to Home <ArrowRight size={16} className="ml-2" data-id="element-1852" />
          </button>
        </div>

        {/* Lab Request (Optional) */}
        <div className="bg-white rounded-2xl p-5 border border-ui-border shadow-sm" data-id="element-1853">
          <div className="flex justify-between items-center mb-2" data-id="element-1854">
            <div className="flex items-center" data-id="element-1855">
              <FlaskConical size={20} className="text-teal-600 mr-2" data-id="element-1856" />
              <h2 className="font-bold text-text-main" data-id="element-1857">Lab Request</h2>
            </div>
          </div>
          <p className="text-sm text-text-secondary mb-4" data-id="element-1858">
            Full Blood Count (FBC) and Malaria Parasite test recommended if
            fever persists after 3 days.
          </p>
          <button className="w-full border border-teal-600 text-teal-600 font-semibold py-3 rounded-xl text-sm" data-id="element-1859">
            Book Lab Test
          </button>
        </div>

        {/* Rating */}
        <div className="bg-white rounded-2xl p-5 border border-ui-border shadow-sm text-center" data-id="element-1860">
          <h2 className="font-bold text-text-main mb-2" data-id="element-1861">
            How was your experience?
          </h2>
          <p className="text-xs text-text-secondary mb-4" data-id="element-1862">
            Rate Dr. Amina Bello
          </p>
          <div className="flex justify-center space-x-2 mb-4" data-id="element-1863">
            {[1, 2, 3, 4, 5].map(star => <button key={star} className="text-gray-300 hover:text-status-warning transition-colors" data-id="element-1864">
                <Star size={32} className="fill-current" data-id="element-1865" />
              </button>)}
          </div>
          <button className="text-brand-primary text-sm font-medium" data-id="element-1866">
            Leave a written review
          </button>
        </div>
      </div>

      <div className="p-6 bg-white border-t border-ui-border" data-id="element-1867">
        <button onClick={() => navigate('/home')} className="w-full bg-ui-card text-text-main font-semibold py-4 rounded-xl border border-ui-border active:bg-gray-100 transition-colors" data-id="element-1868">
          Back to Home
        </button>
      </div>
    </div>;
}